import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.7664 6.70006V4.96676C12.7664 4.73691 12.6751 4.51648 12.5126 4.35395C12.35 4.19142 12.1296 4.10011 11.8998 4.10011H5.83323V3.23347C5.83323 3.00362 5.74193 2.78318 5.5794 2.62066C5.41687 2.45813 5.19644 2.36682 4.96659 2.36682H2.36665C2.1368 2.36682 1.91636 2.45813 1.75383 2.62066C1.59131 2.78318 1.5 3.00362 1.5 3.23347V12.651C1.50326 12.887 1.59139 13.1139 1.74826 13.2903C1.90512 13.4666 2.12024 13.5806 2.35425 13.6113C2.58825 13.642 2.82549 13.5875 3.02256 13.4576C3.21963 13.3277 3.36335 13.1312 3.42742 12.9041L4.78575 7.32462C4.8382 7.14431 4.94781 6.98591 5.09806 6.87327C5.24832 6.76063 5.4311 6.69984 5.61888 6.70006H13.6331C13.7659 6.70001 13.897 6.7305 14.0162 6.78918C14.1353 6.84786 14.2394 6.93316 14.3204 7.03847C14.4014 7.14379 14.4571 7.26631 14.4831 7.39657C14.5092 7.52684 14.505 7.66135 14.4708 7.78972L13.1997 12.9896C13.1506 13.1742 13.0418 13.3374 12.8903 13.4538C12.7388 13.5702 12.553 13.6333 12.362 13.6332H2.48047",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFolder;
